import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const getColor = ({ theme: { color }, color: tagColor }) => {
  switch (tagColor) {
    case 'beta':
      return color.colorPurple70;
    default:
      return color.colorWhite;
  }
};

const getBackground = ({ theme: { color }, color: tagColor }) => {
  switch (tagColor) {
    case 'gray':
      return color.colorGrayBlue50;
    case 'orange':
      return color.colorOrange;
    case 'yellow':
      return color.colorYellow;
    case 'violet':
      return color.colorViolet;
    case 'purple':
      return color.colorPurple;
    case 'teal':
      return color.colorTeal;
    case 'green':
      return color.colorGreen;
    case 'turquoise':
      return color.colorTurquoise;
    case 'dark-pink':
      return color.colorPinkDark;
    case 'beta':
      return color.colorPurple30;
    case 'pink':
    case 'new':
    default:
      return color.colorPink;
  }
};

const getMargin = ({ position, theme }) => {
  const property = position === 'left' ? 'margin-right' : 'margin-left';
  return `${property}: ${theme.scale.scaleDown03};`;
};

export const StyledTag = styled.span`
  ${themeGet('font.whitneySemibold')}
  ${getMargin}
  color: ${getColor};
  background: ${getBackground};
  vertical-align: super;
  position: relative;
  top: -2px;
  display: inline;
  padding: ${themeGet('scale.scaleDown04')} ${themeGet('scale.scaleDown03')};
  font-size: ${themeGet('scale.scaleDown02')};
  line-height: normal;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  border-radius: ${themeGet('border.borderRadius')};
  box-shadow: 0 0 1px 0 #a8b9d5, 0 4px 8px -2px #ebf2ff;
`;

export default StyledTag;
